export default __webpack_public_path__ + "static/media/outdoor_green.0e61ee49.mp4";